import { Controller } from "@hotwired/stimulus"

// Keeps selected query keys (e.g. sort) when filter links/forms sit outside the results turbo-frame.
export default class extends Controller {
  static values = { keys: { type: Array, default: ["sort"] } }

  merge(event) {
    const link = event.target.closest("a[href]")
    if (!link || !this.element.contains(link)) return

    const next = new URL(link.href, window.location.origin)
    const current = new URL(window.location.href)

    this.keysValue.forEach((key) => {
      const value = current.searchParams.get(key)
      if (value != null && value !== "" && !next.searchParams.has(key)) {
        next.searchParams.set(key, value)
      }
    })

    link.href = `${next.pathname}${next.search}${next.hash}`
  }

  mergeForm(event) {
    const form = event.target
    if (!(form instanceof HTMLFormElement) || !this.element.contains(form)) return

    const current = new URL(window.location.href)
    this.keysValue.forEach((key) => {
      const value = current.searchParams.get(key)
      if (value == null || value === "") return
      if (form.querySelector(`[name="${CSS.escape(key)}"]`)) return

      const input = document.createElement("input")
      input.type = "hidden"
      input.name = key
      input.value = value
      form.appendChild(input)
    })
  }
}
